import React from 'react';
import { useHistory } from 'react-router-dom';

import { TemplateList } from '@weezevent/templar';
import { Card, ContentCard } from '@weezevent/nacre';

export const TemplatesList = () => {
    const history = useHistory();

    return (
        <Card>
            <ContentCard>
                <TemplateList redirectionAction={template => history.push(`templates/${template.id}`)} />
            </ContentCard>
        </Card>
    );
};
